var PDFBlock = require("./block");
var util = require("./util");
var PDFText = require("./text");
var colorUtil = require("./colors");
var a11y = require("./a11y");
function PDFListItem(options, children) {
    PDFBlock.call(this, options, children);
    this.markerText = util.getOption(options, "markerText", "\u2022");
    this.size = util.getOption(options, "size", 16);
    this.font = util.getOption(options, "font", "helvetica");
    this.color = util.getOption(options, "color", "black");
    this.ascender = 0.75; // TODO: Fix this. This is specific to Helvetica
}
util.inherits(PDFListItem, PDFBlock);
PDFListItem.prototype.draw = function (cursor) {
    var measure = this.calc(cursor);
    if (!measure.firstBaseline) {
        this.children.unshift(new PDFText({ size: this.size, font: this.font }, " "));
        this.cache.clear();
        measure = this.calc(cursor);
    }
    var ret;
    function drawFn() {
        var saveRole = this.role;
        cursor._ignoreA11y = false;
        var space = (this.size * this.ascender * 2) / 3;
        var textWidth = cursor.doc.getStringUnitWidth(this.markerText, { kerning: [] }) * this.size;
        function drawLabel() {
            a11y.marked(cursor, function () {
                cursor.doc.setFont(this.font, "normal");
                cursor.doc.setFontSize(this.size);
                cursor.doc.setTextColor.apply(cursor.doc, colorUtil.getRGB(this.color));
                cursor.doc.text(this.markerText, cursor.x - (space + textWidth), cursor.y + measure.firstBaseline);
            }, null, this);
        }
        if (!this.splitLocation || this.splitLocation === "top") {
            if (!this.role || this.role === "list-item")
                a11y.structure(cursor, "list-label", drawLabel, this);
            else
                drawLabel.call(this);
        }
        this.role = "list-body";
        ret = PDFBlock.prototype.draw.call(this, cursor);
        this.role = saveRole;
    }
    if (!this.role || this.role === "list-item")
        a11y.structure(cursor, "list-item", drawFn, this);
    else
        drawFn.call(this);
    return ret;
};
module.exports = PDFListItem;
//# sourceMappingURL=module.js.map